import { Component } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ApColumnBase } from './../ap-column-base';

import { ColumnFindControlDto } from 'webcommon/shared';

@Component({
  selector: 'ap-column-findcontrol',
  templateUrl: './ap-column-findcontrol.component.html',
  styleUrls: ['./ap-column-findcontrol.component.less'],
})
export class ApColumnFindcontrolComponent extends ApColumnBase<ColumnFindControlDto> {
  public override Id: string;
  public findcontrolType: string;
  public list: string[] = [];
  public isDisable: boolean;
  public isSingleSelect = true;
  public formGroup: FormGroup<any> | null = null;
  public controlName: string | null = null;
  public messageOverrides: Record<string, string> = {};

  constructor() {
    super();
  }

  load(): void {
    this.findcontrolType = this.columnInfoDto.FindControlType;
    this.list[0] = this.columnInfoDto.Callback(this.dataItem);
    this.isDisable = this.columnInfoDto.IsDisable(this.dataItem);
    this.isSingleSelect = this.columnInfoDto.SingleSelect;
    this.formGroup = this.columnInfoDto.FormGroup?.(this.dataItem) ?? null;
    this.controlName = this.columnInfoDto.ControlName ?? null;
    this.messageOverrides = this.columnInfoDto.MessageOverrides ?? {};
  }

  onChange(event: any) {
    if (this.columnInfoDto.Change) {
      this.columnInfoDto.Change({ dataItem: this.dataItem, Pk: event });
    }
  }
}
